import React from "react";
import classnames from "classnames";
import { Language } from "../../types";
import { StoreFunctions } from "../context/Store";

export interface LanguageBlockElementProps {
  data: Language;
  index: number;
  toggleLanguage: StoreFunctions["toggleLanguage"];
  setLanguageValue: StoreFunctions["setLanguageValue"];
}

export interface LanguageBlockElementState {}

export const LanguageBlockElement = (props: LanguageBlockElementProps) => {
  const { index, data, toggleLanguage, setLanguageValue } = props;
  const { active, name, value } = data;
  return (
    <div className="select-block-element language">
      <div className="row">
        <div className="col-6 d-flex align-items-center">
          <div
            className={classnames("mark", { active })}
            onClick={() => toggleLanguage(index)}
          ></div>
          <span>{name}</span>
        </div>
        <div className="col-6 d-flex align-items-center">
          {new Array(5).fill("").map((_i: string, dot: number) => (
            <span
              key={dot}
              onClick={() => {
                setLanguageValue(index, dot + 1);
              }}
              className={classnames("dot", {
                "active-language": active,
                active: dot + 1 <= value,
              })}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageBlockElement;
